module.exports = __webpack_public_path__ + "img/avatar7.6f4f4269.png";